import Echo from "laravel-echo";
import Pusher from "pusher-js";
import storage from "infrastructure/utils/storage";

type EchoConfig = {
  authEndpoint: string;
};

export type NotificationsEchoInstance = InstanceType<typeof Echo>;

const DEFAULT_REVERB_PORT = 443;

const parsePort = (value: string | undefined) => {
  if (!value) {
    return DEFAULT_REVERB_PORT;
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : DEFAULT_REVERB_PORT;
};

const getReverbAppKey = (): string | undefined => {
  const key = process.env.REACT_APP_REVERB_APP_KEY;
  if (typeof key !== "string") {
    return undefined;
  }
  const trimmed = key.trim();
  return trimmed.length > 0 ? trimmed : undefined;
};

export const isReverbBroadcastingConfigured = (): boolean =>
  Boolean(getReverbAppKey());

export const createNotificationsEchoClient = ({
  authEndpoint,
}: EchoConfig): NotificationsEchoInstance | null => {
  const appKey = getReverbAppKey();
  if (!appKey) {
    return null;
  }

  const token = storage.getItem("access_token");

  (window as Window & { Pusher?: typeof Pusher }).Pusher = Pusher;

  return new Echo({
    broadcaster: "reverb",
    key: appKey,
    wsHost: process.env.REACT_APP_REVERB_HOST,
    wsPort: parsePort(process.env.REACT_APP_REVERB_PORT),
    wssPort: parsePort(process.env.REACT_APP_REVERB_PORT),
    forceTLS: process.env.REACT_APP_REVERB_SCHEME === "https",
    enabledTransports: ["ws", "wss"],
    authEndpoint,
    auth: {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        Accept: "application/json",
        "X-Authorization": process.env.REACT_APP_API_KEY_WEB_ADMIN ?? "",
      },
    },
  });
};
